/**
 * Backend list endpoints may return a bare array or a paginated wrapper `{ results: T[] }`.
 */
export function normalizeListResponse<T>(data: unknown): T[] {
    if (Array.isArray(data)) {
        return data as T[]
    }
    if (
        data &&
        typeof data === 'object' &&
        'results' in data &&
        Array.isArray((data as { results: unknown }).results)
    ) {
        return (data as { results: T[] }).results
    }
    return []
}
